import { ProviderType } from '../types/ObjectTypes';
import { checkSchema } from '../components/forms/SchemaFormTemplates/checkSchema';

export type RouteKind = 'webhook' | 'push-only' | 'standard';

export function getRouteKind(providerType: ProviderType): RouteKind {
  const hasPullConfig = providerType.actions
    ?.filter((a) => a.type !== 'push')
    .some((a) => checkSchema(a));
  if (hasPullConfig) return 'standard';
  if (providerType.value === 'generic_webhooks') return 'webhook';
  return 'push-only';
}

export function providerHasPushAction(providerType: ProviderType): boolean {
  return providerType.actions?.some((a) => a.type === 'push') ?? false;
}
